import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { RequirementItemExpansions } from "./RequirementItemExpansions";
export var RequirementsExpansions = function (_a) {
    var resources = _a.resources;
    var displayedResources = resources.filter(function (resource) { return resource.resource.id !== IdResource.Money; });
    if (displayedResources.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    var requirements = displayedResources.map(function (resourceInfo, index) { return (React.createElement(RequirementItemExpansions, { key: index, resourceInfo: resourceInfo })); });
    return (React.createElement("div", { className: "expansion-menu__requirement-wrapper " + IdStyles.BuyExpansionRequirementContainer }, requirements));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/RequirementsExpansions.tsx
// module id = 2868
// module chunks = 3